module.exports = "/assets/-4rwIx9SHk.svg";